import { useContext, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import moment from "moment";

import RequestHook from "../../hooks/RequestHook";

import { initialDate } from "../../constants/constants";
import { DataContext } from "../../context/DataContext";
import { getStayingDates } from "../../helpingFunctions/utilities";
import { WhatsOnDataContext } from "../../context/WhatsOnDataContext";

const INTERVAL_15_MIN_PERIOD = 900000;

const WhatsOnGuideLogic = () => {
  const { getGuide } = useContext(WhatsOnDataContext);
  const { getInternalActivityItinerary } = RequestHook();
  const { reservation } = useContext(DataContext);

  const { pathname } = useLocation();
  const isInPublicPage = pathname.includes("public");
  const isNotPrivate = isInPublicPage || pathname.includes("team");

  const { hotel } = useParams();

  const [selectedItemId, setSelectedItemId] = useState(null);
  const [internalActivityItinerary, setInternalActivityItinerary] = useState(
    []
  );

  const constructParams = async () => {
    try {
      if (isNotPrivate) {
        return {
          showDates: [initialDate],
          hotel,
        };
      }

      const dates = getStayingDates(
        reservation.ArrivalDate,
        reservation.DepartureDate
      );
      const formatedDates = dates.map((date) =>
        moment(new Date(date)).format("YYYY-MM-DD")
      );
      return {
        showDates: formatedDates,
        hotel: reservation.Hotel.Title,
      };
    } catch (error) {
      return {
        showDates: [initialDate],
        hotel,
      };
    }
  };

  const internalActivityItineraryHandler = async (params) => {
    try {
      const data = await getInternalActivityItinerary({
        ReservationNumber: reservation.ReservationNumber,
        CRSNumber: reservation.CRSNumber,
        LastName: reservation.LastName,
        ...params,
      });

      setInternalActivityItinerary(data);
    } catch (error) {
      console.error(
        `${new Date()} Error in internalActivityItineraryHandler func in WhatsOnGuideLogic file ${
          error.message
        }`
      );
    }
  };

  const scheduleDataFetch = async () => {
    try {
      const params = await constructParams();
      await getGuide(params);

      if (isInPublicPage) {
        setInterval(async () => {
          const params = await constructParams();
          await getGuide(params);
        }, INTERVAL_15_MIN_PERIOD);
      }
    } catch (error) {
      console.error(
        `${new Date()} Error in scheduleDataFetch func ${error.message}`
      );
    }
  };

  useEffect(() => {
    scheduleDataFetch();
    if (!isNotPrivate) {
      internalActivityItineraryHandler({
        IsInternalActivity: true,
      });
    }
  }, []);

  return {
    selectedItemId,
    internalActivityItinerary,
    setSelectedItemId,
    internalActivityItineraryHandler,
  };
};

export default WhatsOnGuideLogic;
